export default {
  version: "9.2.0",
  iosSDKVersion: "4.6.7",
  androidSDKVersion: "5.2.1"
};